import { Component, Input } from '@angular/core';
import { TextDividerComponent } from '../text-divider/text-divider.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-section',
  imports: [TextDividerComponent, CommonModule],
  templateUrl: './section.component.html',
  styleUrls: ['./section.component.scss'],
})
export class SectionComponent {
  @Input() sectionTitle: string = '';
  @Input() isWarning: boolean = false;
}
